export enum PRODUCT_DETAIL_COLLAPSIBLE_KEY {
  E_CHAIN_INSTALLATION_TYPE,
  E_CHAIN_MOUNTING_BRACKETS,
  E_CHAIN_INTERIOR_SEPARATION,
  E_CHAIN_SUPPORT_TRAYS,
  E_CHAIN_GUIDE_TROUGH,
}

export enum PRODUCT_TABS_KEY {
  PRODUCT_SELECTION,
  DESCRIPTION,
  TECHNICAL_DETAILS,
  SUITABLE_PRODUCTS,
  ONLINE_TOOLS,
  APPLICATION_EXAMPLES,
  DOWNLOAD_ASSETS,
}

export const DEFAULT_PRODUCT_TABS = [
  PRODUCT_TABS_KEY.DESCRIPTION,
  PRODUCT_TABS_KEY.TECHNICAL_DETAILS,
  PRODUCT_TABS_KEY.SUITABLE_PRODUCTS,
  PRODUCT_TABS_KEY.ONLINE_TOOLS,
  PRODUCT_TABS_KEY.APPLICATION_EXAMPLES,
  PRODUCT_TABS_KEY.DOWNLOAD_ASSETS,
];

export const RC_PRODUCT_TABS = [
  PRODUCT_TABS_KEY.TECHNICAL_DETAILS,
  PRODUCT_TABS_KEY.DESCRIPTION,
  PRODUCT_TABS_KEY.SUITABLE_PRODUCTS,
  PRODUCT_TABS_KEY.ONLINE_TOOLS,
  PRODUCT_TABS_KEY.APPLICATION_EXAMPLES,
  PRODUCT_TABS_KEY.DOWNLOAD_ASSETS,
];

export const ECHAIN_PRODUCT_TABS = [
  PRODUCT_TABS_KEY.PRODUCT_SELECTION,
  PRODUCT_TABS_KEY.DESCRIPTION,
  PRODUCT_TABS_KEY.TECHNICAL_DETAILS,
  PRODUCT_TABS_KEY.SUITABLE_PRODUCTS,
  PRODUCT_TABS_KEY.DOWNLOAD_ASSETS,
];

export const DRYLIN_LINEAR_TECHNOLOGY_PRODUCT_TABS = [
  PRODUCT_TABS_KEY.SUITABLE_PRODUCTS,
  PRODUCT_TABS_KEY.DESCRIPTION,
  PRODUCT_TABS_KEY.TECHNICAL_DETAILS,
  PRODUCT_TABS_KEY.ONLINE_TOOLS,
  PRODUCT_TABS_KEY.APPLICATION_EXAMPLES,
  PRODUCT_TABS_KEY.DOWNLOAD_ASSETS,
];

export const TRIFLEX_PRODUCT_TABS = [
  PRODUCT_TABS_KEY.SUITABLE_PRODUCTS,
  PRODUCT_TABS_KEY.PRODUCT_SELECTION,
  PRODUCT_TABS_KEY.DESCRIPTION,
  PRODUCT_TABS_KEY.TECHNICAL_DETAILS,
  PRODUCT_TABS_KEY.DOWNLOAD_ASSETS,
];
